import React from 'react';
import Select from 'react-select';

import FormRow from '../../../app/components/FormRow';
import BudgetSelector from '../Selects/BudgetSelector';
import { ClientSelector } from '../Selects/ClientSelector';
import { getCurrencyOptions } from '../../../utils/currencyFormatUtils';
import { NewDateRangePicker } from '../../../app/components/NewDateRangePicker';
import type { Option } from '../Selects/Selector';

import type { FilterYearFieldProps } from './types/FilterYearTypes';
import { createSelectOptions } from './utils/filterYearUtils';

export const FilterYearBasicFields: React.FC<FilterYearFieldProps> = ({
  props,
  state,
  t,
  tk,
}) => {
  const { typeOptions, statusOptions } = createSelectOptions(t);

  return (
    <>
      {props.withInvoiceType && (
        <FormRow controlId="invoiceType" label={t(tk.filter.invoiceType)}>
          <Select
            value={
              state.type
                ? typeOptions.find(({ value }) => state.type === value)
                : null
            }
            options={typeOptions}
            onChange={option => state.setType(option?.value)}
            placeholder={t(tk.component.pointOut)}
            isClearable={true}
          />
        </FormRow>
      )}

      {props.withStatus && (
        <FormRow controlId="status" label={t(tk.filter.invoiceStatus)}>
          <Select
            value={
              state.status
                ? statusOptions.find(({ value }) => state.status === value)
                : null
            }
            options={statusOptions}
            onChange={option => state.setStatus(option?.value)}
            placeholder={t(tk.component.pointOut)}
            isClearable={true}
          />
        </FormRow>
      )}
      {props.withBudget && (
        <FormRow controlId="budget" label={t(tk.common.budget)}>
          <BudgetSelector
            value={state.budget}
            onChange={option => state.setBudget(option?.value)}
            clearable={true}
          />
        </FormRow>
      )}

      {props.withCurrency && (
        <FormRow controlId="currency" label={t(tk.common.currency)}>
          <Select
            value={
              state.currency
                ? getCurrencyOptions().find(
                    ({ value }) => state.currency === value,
                  )
                : null
            }
            options={getCurrencyOptions()}
            onChange={option => state.setCurrency(option?.value)}
            placeholder={t(tk.component.pointOut)}
            isClearable={true}
          />
        </FormRow>
      )}

      {props.withClient && (
        <FormRow controlId="client" label={t(tk.common.client)}>
          <ClientSelector
            valueId={state.clientId}
            onChange={option => state.setClientId((option as Option)?.value)}
            clearable={true}
          />
        </FormRow>
      )}

      {props.withDataSales && (
        <FormRow controlId="dataSales" label={t(tk.filter.dateSale)}>
          <div className="small-calendar">
            <NewDateRangePicker
              onChange={value =>
                state.setSaleDate(
                  value as unknown as [Date | null, Date | null] | null,
                )
              }
              value={state.saleDate}
            />
          </div>
        </FormRow>
      )}

      {props.withDataInvoices && (
        <FormRow controlId="dataInvoices" label={t(tk.filter.dateInvoices)}>
          <div className="small-calendar">
            <NewDateRangePicker
              onChange={value =>
                state.setInvoiceDate(
                  value as unknown as [Date | null, Date | null] | null,
                )
              }
              value={state.invoiceDate}
            />
          </div>
        </FormRow>
      )}
    </>
  );
};
